import { Injectable, Inject } from '@angular/core';
import { IFixedPrice } from './IFixedPrice';
import { Observable, Observer } from 'rxjs';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { LoggingService } from '../shared/services/logging/logging.service';
import { tap } from 'rxjs/operators';
import { ITask } from '../lookups/ITask';
import moment from 'moment';
import { IDeleteResponse, IFixedPriceResponse } from './IFixedPriceResponse';

@Injectable({
  providedIn: 'root'
})
export class FixedPriceService {
  // public fpinvoicesMTE: IFixedPriceMTE = { ManualTxnExpense: [] };

  private uri = `${environment.apiLocation}/ManualTxnExpense`;
  public roles$: Observable<Array<IFixedPrice>> = new Observable<Array<IFixedPrice>>(
    o => (this._observer = o)
  );
  constructor(
    @Inject(HttpClient) private http: HttpClient,
    @Inject(LoggingService) private log: LoggingService
  ) { }

  private _observer: Observer<Array<IFixedPrice>>;



  // Service call for loading data for the page
  public getFixedPrice (params: {
    Txnstartdate?: Date,
    Txnenddate?: Date,
    Tasks?: Array<ITask>,
    CalcType?: string,
    CNOnly?: boolean
  }): Observable<Array<IFixedPrice>> {
    const today = new Date();
    const request = {
      Txnstartdate: params && params.Txnstartdate || moment(today).add(-1, 'years').format('M/D/YYYY'),
      Txnenddate: params && params.Txnenddate || moment(today).format('M/D/YYYY'),
      Tasks: params && params.Tasks || [],
      CalcType: 'FP',
      CNOnly: params && params.CNOnly
    };

    return this.http
      .post<Array<IFixedPrice>>(this.uri, request)
      .pipe(
        tap(data => this.log.verbose({ type: 'FixedPriceService:getFixedPrices:reponse', data }))
      );
  }


  // Service call for updates
  public putFixedPrice (fpinvoices: Array<IFixedPrice>): Observable<IFixedPriceResponse> {
    this.log.debug({ type: 'FixedPriceService:putFixedPrice', fpinvoices });
    return this.http.put<IFixedPriceResponse>(this.uri, { ManualTxnExpense: fpinvoices })
      .pipe(res => {
        this.log.verbose({ type: 'FixedPriceService:putFixedPrice:reponse', res });
        return res;
      });
  }

  public deleteFixedPrice(
    fpIDs: Array<number>
): Observable<IDeleteResponse> {
    this.log.debug({ type: 'FixedPriceService:deleteFixedPrice', fpIDs });

    return (
        this.http
            // TODO: change to .delete<IResponse> when upgrading to NG7
            .request<IDeleteResponse>('DELETE', this.uri, {
                body: { EntityIDs: fpIDs }
            })
            .pipe(
                tap(data =>
                    this.log.verbose({
                        type: 'FixedPriceService:deleteFixedPrice:reponse',
                        data
                    })
                )
            )
    );
}
}
